import { Button, UIHeading3, UIText2 } from '@cian/ui-kit';
import { IconActionClose12 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './EmptyListing.css';
import { IActiveFilter } from '../../hooks/useActiveFilters';

function getSubtitle(hasActiveFilters: boolean) {
  if (hasActiveFilters) {
    return (
      <>
        Сбросьте один или&nbsp;несколько фильтров&nbsp;—
        <br />
        что‑нибудь найдём!
      </>
    );
  }

  return (
    <>
      Попробуйте поискать в&nbsp;другом районе
      <br />
      или&nbsp;изменить фильтры
    </>
  );
}

interface IEmptyListingProps {
  onShow: () => void;
  activeFilters?: IActiveFilter[];
  showAllFiltersButton?: boolean;
  showResetAllFiltersButton?: boolean;
  showEditFiltersButton?: boolean;
  onShowAllFilters?: () => void;
  onResetAllFilters?: () => void;
}

// Компонент пустого листинга с отображением активных фильтров
export const EmptyListing = ({
  onShow,
  activeFilters = [],
  showAllFiltersButton,
  showEditFiltersButton,
  showResetAllFiltersButton,
  onShowAllFilters,
  onResetAllFilters,
}: IEmptyListingProps) => {
  const hasActiveFilters = activeFilters.length > 0;

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>, filter: IActiveFilter) => {
    if (e.key === 'Enter' || e.key === ' ') {
      filter.onReset();
    }
  };

  React.useEffect(() => {
    onShow();
  }, [onShow]);

  return (
    <div className={styles.root}>
      <UIHeading3>Нет&nbsp;вариантов по&nbsp;вашему запросу</UIHeading3>
      <div className={styles['main-text']}>
        <UIText2 color="gray60_100">{getSubtitle(hasActiveFilters)}</UIText2>
      </div>

      {/* Отображение активных фильтров для сброса */}
      <div className={styles['filters-list']} data-testid="EmptyListing.ActiveFilters">
        {activeFilters.map(filter => (
          <div key={filter.id} className={styles['filter-item']} data-testid={`empty-listing_filter_${filter.id}`}>
            <span className={styles['filter-label']}>
              <UIText2>{filter.label}</UIText2>
            </span>
            <div
              className={styles['filter-reset']}
              onClick={filter.onReset}
              data-testid={`empty-listing_filter-reset_${filter.id}`}
              role="button"
              tabIndex={0}
              onKeyDown={e => handleKeyDown(e, filter)}
            >
              <IconActionClose12 />
            </div>
          </div>
        ))}
        {showAllFiltersButton && (
          <Button theme="fill_white_primary" size="XS" onClick={onShowAllFilters}>
            Все фильтры
          </Button>
        )}
        {showResetAllFiltersButton && (
          <Button theme="fill_white_primary" size="XS" onClick={onResetAllFilters}>
            Сбросить все фильтры
          </Button>
        )}
        {showEditFiltersButton && (
          <Button theme="fill_white_primary" size="M" onClick={onShowAllFilters}>
            Изменить фильтры
          </Button>
        )}
      </div>
    </div>
  );
};
